import { useQuery } from '@tanstack/react-query';
import { getPaymentClouderServices } from '../services';

export default function useGetPaymentClouderServices() {
  return useQuery({
    queryKey: ['paymentClouderServices'],
    queryFn: getPaymentClouderServices,
    select: ({ data }) =>
      data.payment_services.map((service) => {
        if (service === 'SAMEDAY') return 'SAME_DAY';
        return service;
      }),
  });
}
